export const extractFlyerName = (url: string): string => {
  const segments = url.split('/flyers/');
  if (segments.length < 2) {
    return '';
  } else {
    return segments[1];
  }
};
